import Lottie from 'lottie-react';
import React, { useEffect, useState } from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
//Page Import
import Home from './pages/Home/Index'
import ProductList from './pages/Product/List'
import ArticelsList from './pages/Article/List'
import ArticleDetail from './pages/Article/Detail'
import Profile from './pages/Profile/Index'
import AboutUs from './pages/AboutUs/Index'
import ContactUs from './pages/ContactUs/Index'
import Product from './pages/Product/Detail'
import Cart from './pages/Cart/Cart'
import InternalServer from './pages/Errors/Index';
import Unpaid from './pages/Profile/Unpaid';
import Paid from './pages/Profile/Paid';
import AdminFactor from './pages/Profile/AdminFactor';
import Factor from './pages/Cart/Factor'
import NotFound from './pages/Errors/NotFound'
import './scss/style.scss';
import './exStyles.scss'
const App = () => {
    const [lang, setLang] = useState('')
    useEffect(() => {
        if (window.location.pathname.includes('/ar/') || window.location.pathname === "/ar" || localStorage.getItem('lang') === 'ar') {
            setLang('ar')
            localStorage.setItem('lang', 'ar')
        }
        else {
            localStorage.setItem('lang', 'fa')
            setLang('fa')
        }
    }, [])
    if (lang) {
        return (
            <BrowserRouter>
                <Switch>
                    <Route
                        path="/verify"
                        render={(props) => <Factor {...props} lang={lang} />}
                    />
                    <Route
                        path="/factor/:pid"
                        render={(props) => <Factor {...props} lang={lang} />}
                    />
                    <Route
                        path='/products/page/:pageNumber/:mainCategoryId?/:subCategoryId?/:secondaryCategoryId?'
                        render={(props) => (
                            <ProductList {...props} lang={lang} />
                        )}
                    />
                    <Route
                        path='/articels/page/:pageNumber/:mainCategoryId?'
                        render={(props) => (
                            <ArticelsList {...props} lang={lang} />
                        )}
                    />
                    <Route
                        path='/article/:aid'
                        render={(props) => (
                            <ArticleDetail title='' {...props} lang={lang} />
                        )}
                    />
                    <Route
                        path='/article/:aid/:title'
                        render={(props) => (
                            <ArticleDetail {...props} lang={lang} />
                        )}
                    />
                    <Route
                        path='/product/:pid'
                        render={(props) => (
                            <Product {...props} lang={lang} />
                        )}
                    />
                    <Route
                        path='/Factors/detail/:id'
                        render={(props) => (
                            <AdminFactor {...props} lang={lang} />
                        )}
                    />
                    <Route
                        path='/articels'
                        render={(props) => (
                            <ArticelsList {...props} lang={lang} />
                        )}
                    />
                    <Route
                        path='/products'
                        render={(props) => (
                            <ProductList {...props} lang={lang} />
                        )}
                    />
                    <Route
                        path='/AboutUs'
                        render={(props) => (
                            <AboutUs {...props} lang='fa' />
                        )}
                    />
                    <Route
                        path='/Ar/AboutUs'
                        render={(props) => (
                            <AboutUs {...props} lang='ar' />
                        )}
                    />
                    <Route
                        path='/ContactUs'
                        render={(props) => (
                            <ContactUs {...props} lang='fa' />
                        )}
                    />
                    <Route
                        path='/Ar/ContactUs'
                        render={(props) => (
                            <ContactUs {...props} lang='ar' />
                        )}
                    />

                    <Route
                        path='/profile/products-insert'
                        render={(props) => (
                            <Profile {...props} targetTab={'products-insert'} />
                        )}
                    />

                    <Route
                        path='/profile/products-edit/:pid'
                        render={(props) => (
                            <Profile {...props} targetTab={'products-edit'} />
                        )}
                    />

                    <Route
                        path='/profile/products-list/:pageNumber?/:mainCat?/:subCat?/:secCat?/:pid?'
                        render={(props) => (
                            <Profile {...props} targetTab={'products-list'} />
                        )}
                    />

                    {/* <Route
                        path='/profile/products/list/:pageNumber/:pid?'
                        render={(props) => (
                            <Profile {...props} targetTab={'products'} />
                        )}
                    />

                    <Route
                        path='/profile/products/edit/:pid/:pageNumber?'
                        render={(props) => (
                            <Profile {...props} targetTab={'products'} />
                        )}
                    /> */}

                    <Route
                        path='/Profile/:tabName'
                        render={(props) => (
                            <Profile {...props} targetTab={''} />
                        )}
                    />
                    <Route
                        path='/paid-invoices/:id'
                        render={(props) => (
                            <Paid {...props} lang={lang} />
                        )}
                    />
                    <Route
                        path='/unpaid-invoices/:id'
                        render={(props) => (
                            <Unpaid {...props} lang={lang} />
                        )}
                    />
                    <Route
                        path='/Profile'
                        render={(props) => (
                            <Profile {...props} targetTab={''} />
                        )}
                    />
                    <Route
                        path='/Cart'
                        render={(props) => (
                            <Cart {...props} />
                        )}
                    />
                    {/* <Route exact path="/product" render={(props) => <MediumSizeBoxedLayout lang={lang} {...props} />} />
                    <Route exact path="/cart" render={(props) => <MediumSizeBoxedLayout lang={lang} {...props} />} />
                    <Route exact path="/profile" render={(props) => <MediumSizeBoxedLayout lang={lang} {...props} />} /> */}
                    <Route exact path="/ar" component={() => <Home lang='ar' />} />
                    <Route exact path="/" component={() => <Home lang={lang} />} />
                    <Route path="/500" component={InternalServer} />
                    <Route path="*" component={NotFound} />
                </Switch>
            </BrowserRouter>
        )
    }
    else {
        return (
            <div className="loading">
                <div class="loader">
                    {/* <Lottie  loop={true} autoplay={true} animationData={animationData} style={{width:'400px',height:'400px',margin:'0 auto'}} /> */}
                </div>
            </div>
        )
    }

}
export default App